module.exports = __webpack_public_path__ + "img/house.23d92153.png";